var React = require('react');
var Item = require('./item');
var Group = require('./group');
var cx = require('classnames');

class GroupedItemsCollection extends React.Component {

  render () {
    return (
      <div className="body">
        <div className={cx('grouped-items', (this.props.hasGroupedItems ? null : 'no-groups'))}>
          {this.props.items.map(function (item, index) {
            if (item.group) {
              return <Group group={item} toggleItems={this.props.toggleItems} key={index} showChildren={item.showChildren}/>;
            } else {
              return <Item item={item} toggle={this.props.toggleItems} key={index} />;
            }
          }.bind(this))}
        </div>
      </div>
    )
  }

}

module.exports = GroupedItemsCollection;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/items_selector/items_collection.jsx